export default "/_next/static/images/product--inbox-legacy-b3c7e3677db33bc849d9ff552a4dafd2.svg";